import { isMobile } from 'utils/isMobile';

export const getStyles = (theme) => {
  const direction = isMobile() ? 'column' : 'row';
  const mainTopMargin = isMobile() ? '20px' : '61px';
  const formTopMargin = isMobile() ? '20px' : '40px';
  const formLeftMargin = isMobile() ? '0px' : '52px';
  const footerTopMargin = isMobile() ? '50px' : '0px';

  return {
    mainContainer : {
      display        : 'flex',
      justifyContent : 'center',
      marginTop      : mainTopMargin,
      marginBottom   : '20px',
    },
    rightPanel : {
      display    : 'flex',
      marginLeft : formLeftMargin,
    },
    formContainer : {
      marginTop : formTopMargin,
    },
    img   : { borderRadius: '10px', width: '250px', height: '454px' },
    title : {
      color      : theme.palette.primary.greenPKD,
      fontFamily : 'Montserrat',
      fontStyle  : 'normal',
      fontWeight : 700,
      fontSize   : '32px',
      lineHeight : '42px',
    },
    titleMobile : {
      display    : 'flex',
      color      : theme.palette.primary.greenPKD,
      fontFamily : 'Montserrat',
      fontStyle  : 'normal',
      fontWeight : 700,
      fontSize   : '24px',
      lineHeight : '34px',
    },
    titleText : {
      display    : 'flex',
      color      : theme.palette.primary.gray8,
      fontFamily : 'Montserrat',
      fontStyle  : 'normal',
      fontWeight : 400,
      fontSize   : '16px',
      lineHeight : '24px',
      a          : {
        color          : theme.palette.primary.blue1,
        fontFamily     : 'Montserrat',
        fontStyle      : 'normal',
        fontWeight     : 700,
        fontSize       : '16px',
        lineHeight     : '24px',
        textDecoration : 'none',
        cursor         : 'pointer',
      },
    },
    btnContainer : {
      display   : 'flex',
      marginTop : '27px',
    },
    btnContainerMobile : {
      display        : 'flex',
      flexDirection  : 'column',
      justifyContent : 'center',
      alignItems     : 'center',
      marginTop      : '10px',
    },
    headers : {
      display        : 'flex',
      flexDirection  : 'column',
      justifyContent : 'center',
      alignItems     : 'center',
    },
    formRow : {
      display       : 'flex',
      flexDirection : direction,
    },
    inputWrapper : {
      display      : 'flex',
      marginBottom : '20px',
    },
    footerContainer : {
      display       : 'flex',
      flexDirection : 'column',
      marginTop     : footerTopMargin,
    },
    field : {
      marginTop : '40px',
    },
  };
};
